import firebase from 'firebase/app';
import { dispatch, getState } from '../../..';
import GeneralFunctions from '../../../general/functions';
import TrapFarmDescriptionActions from './actions';
import * as uuid from 'uuid';
import TrapFarmDescriptionHelper, { ITrapFarmDescription } from '../../../../types/model/masterData/trap/farmDescription';

export default class TrapFarmDescriptionFunctions {
    private static listener ?: () => void;

    public static getList = (refresh ?: boolean) => {

        if (!refresh && TrapFarmDescriptionFunctions.listener) {
            return;
        }

        if (TrapFarmDescriptionFunctions.listener) {
            TrapFarmDescriptionFunctions.listener();
        }

        dispatch(TrapFarmDescriptionActions.setLoading(true));
        dispatch(TrapFarmDescriptionActions.setList([]));

        try {
            
            TrapFarmDescriptionFunctions.listener = TrapFarmDescriptionHelper
                .collection()
                .onSnapshot((snapshot) => {
                    const trapFarmDescriptionState = getState().masterData.trap.farmDescription;

                    const trapFarmDescriptions = trapFarmDescriptionState.farmDescriptions.slice();

                    // "added" | "removed" | "modified"
                    snapshot.docChanges().forEach((f) => {
                        const data = f.doc.data();

                        switch (f.type) {
                        case 'added':
                            trapFarmDescriptions.splice(f.newIndex, 0, data);
                            break;
                        case 'modified':
                            trapFarmDescriptions.splice(f.newIndex, 1, data);
                            break;
                        case 'removed':
                            trapFarmDescriptions.splice(f.oldIndex, 1);
                            break;
                        }
                    });

                    dispatch(TrapFarmDescriptionActions.setList(trapFarmDescriptions));
                    dispatch(TrapFarmDescriptionActions.setLoading(false));
                }, (err) => {
                    GeneralFunctions.generalShowErrorSnackbar('An error while loading descriptions.', err);
                });

        } catch (ex) {
            GeneralFunctions.generalShowErrorSnackbar('An error while loading descriptions.', ex);
            dispatch(TrapFarmDescriptionActions.setLoading(false));
        }
    }

    public static save = async (item : ITrapFarmDescription) => {
        const session = getState().auth.session;

        if (!session) return;
        
        const trapFarmDescriptions = getState().masterData.trap.farmDescription.farmDescriptions;

        if (trapFarmDescriptions.some(x => x.description === item.description && x.id !== item.id)) {
            throw new Error('Description already exists.');
        }

        dispatch(TrapFarmDescriptionActions.setLoading(true));

        try {
            const save : ITrapFarmDescription = {
                ...item,
                createdBy: item.createdBy ? item.createdBy : session.firebaseUser.uid,
                createdByEmployee: item.createdByEmployee ? item.createdByEmployee : session.user.employeeNumber,
                createdByName: item.createdBy ? item.createdByName : session.user.name,
                createdOn: item.createdOn ? item.createdOn : firebase.firestore.Timestamp.now().toMillis(),
                updatedBy: session.firebaseUser.uid,
                updatedByEmployee: session.user.employeeNumber,
                updatedByName: session.user.name,
                updatedOn: firebase.firestore.Timestamp.now().toMillis(),
                id: item.id ? item.id : uuid.v4(),
            };

            await TrapFarmDescriptionHelper.save(save);
        } catch (ex) {
            GeneralFunctions.generalShowErrorSnackbar('An error while saving description.', ex);
            throw ex;
        } finally {
            dispatch(TrapFarmDescriptionActions.setLoading(false));
        }
    }
}